//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/PDM.js";
import "../PDM/PDM.ModelElementRevision.js";
import "../no/ugmath.js";
let d=[[[0,"Category",0,0],[0,"DesignPart",0,"Part",0],[0,"Modified",0,0]],[[["positionInMeters"],"GetTransform",{R_:{orientation:''}},0,0],[["numSubordinateRevision"],"GetDesignSubordinateRevisions",{R_:{designSubordinateRevision:"PDM.DesignSubordinateRevision[]"}},0,0]],[]];
SPLM.PDM.DesignElementRevision = class extends SPLM.PDM.ModelElementRevision{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.PDM.DesignElementRevision";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.PDM.DesignElementRevision.DesignElementCategory = Object.freeze({
    "Shape" : "Shape", "Reuse" : "Reuse", "Promissory" : "Promissory", "DesignControlElement" : "DesignControlElement"});

export default SPLM;